import { useOauth2Provider } from './oauth2.hooks';

type Oauth2ProviderProps = {
  children: React.ReactNode;
};

const Oauth2Provider = ({ children }: Oauth2ProviderProps) => {
  useOauth2Provider();

  return <>{children}</>;
};

export default Oauth2Provider;
